import { isEmpty } from '@fe-util/common';
import { Divider, Icon } from "../../..";
import { getLink } from "../../utils";
import React from 'react';
import "./index.less";
var HeaderTop = function HeaderTop(props) {
  var id = props.id,
    onShoppingCart = props.onShoppingCart,
    onSuperAgent = props.onSuperAgent,
    onChangeLang = props.onChangeLang,
    _props$cartNum = props.cartNum,
    cartNum = _props$cartNum === void 0 ? 0 : _props$cartNum,
    _props$superAgentText = props.superAgentText,
    superAgentText = _props$superAgentText === void 0 ? 'Super Agent' : _props$superAgentText,
    langText = props.langText,
    _props$showCount = props.showCount,
    showCount = _props$showCount === void 0 ? true : _props$showCount,
    tabs = props.tabs,
    originUrl = props.originUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top",
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-left"
  }, !isEmpty(tabs) && /*#__PURE__*/React.createElement(React.Fragment, null, tabs && tabs.map(function (item) {
    return /*#__PURE__*/React.createElement("a", {
      href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
      className: "tab ".concat(item.active ? 'active' : ''),
      key: item === null || item === void 0 ? void 0 : item.value,
      id: "pc-header-tab".concat(item === null || item === void 0 ? void 0 : item.value),
      target: item === null || item === void 0 ? void 0 : item.target
    }, item === null || item === void 0 ? void 0 : item.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-right-item",
    onClick: onShoppingCart
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "shopping-cart",
    className: "item-icon"
  }), showCount && /*#__PURE__*/React.createElement("span", {
    className: "shopping-cart-count"
  }, /*#__PURE__*/React.createElement("span", null, cartNum))), /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical",
    className: "iron-header-top-line"
  }), superAgentText && /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-right-item",
    onClick: onSuperAgent
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "agent",
    className: "item-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "item-text"
  }, superAgentText)), /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical",
    className: "iron-header-top-line"
  }), langText && /*#__PURE__*/React.createElement("div", {
    className: "iron-header-top-right-item",
    onClick: onChangeLang
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "earth",
    className: "item-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "item-text"
  }, langText)))));
};
export default HeaderTop;